import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";

import { ProcessingModalContainer } from "./ProcessingModalStyles";

export const ProcessingModal = (props: any) => {
  const status = Array.isArray(props.status) ? props.status : [props.status];
  const isProcessing = status.some((item) => item === "PROCESSING");
  return (
    <Dialog
      showHeader={false}
      visible={isProcessing}
      onHide={() => {}}
      draggable={false}
      resizable={false}
    >
      <ProcessingModalContainer>
        <ProgressSpinner></ProgressSpinner>
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <p>Processing...</p>
        </div>
      </ProcessingModalContainer>
    </Dialog>
  );
};
